import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { SanctuaryShell, sanctuaryLinks } from './SanctuaryShell';

function SanctuaryPrivacy() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  return (
    <main className="main sanctuary-page-root">
      <SanctuaryShell>
        <article className="sanc-wrap sanc-legal">
          <Link className="sanc-back" to="/projects/sanctuary">
            ← Sanctuary home
          </Link>
          <h1 className="sanc-legal__title">Privacy Policy</h1>
          <p className="sanc-legal__meta">
            <strong>Sanctuary</strong> · com.sahgal.sanctuaryy · Effective: 23 May 2026
            <br />
            Full policy:{' '}
            <a href={sanctuaryLinks.privacyFull} target="_blank" rel="noopener noreferrer">
              sanctuary-privacy-v1.netlify.app
            </a>
          </p>

          <h2>1. Introduction</h2>
          <p>
            Sanctuary is a mobile app for library and study-space management in India.
            Managers register students, assign seats, track study activity, send
            announcements, and collect membership payments. Students use membership,
            check-in, alerts, and renewals where enabled.
          </p>
          <p>
            Data controller: <strong>Abhay Sahgal</strong> / {sanctuaryLinks.business}. Privacy
            requests: <a href={`mailto:${sanctuaryLinks.email}`}>{sanctuaryLinks.email}</a>.
          </p>

          <h2>2. Who this policy applies to</h2>
          <ul>
            <li>
              <strong>Library Managers</strong> — operate a library or study centre with
              Sanctuary.
            </li>
            <li>
              <strong>Students</strong> — registered by a Manager for a seat or membership.
            </li>
          </ul>

          <h2>3. Information we collect</h2>
          <p>We may collect:</p>
          <ul>
            <li>Account &amp; identity (name, email, password via Firebase Auth, phone for Managers, Student ID)</li>
            <li>Library &amp; membership data (library profile, seats, plans, renewals)</li>
            <li>Payment metadata (amounts, transaction IDs; card/UPI details handled by Razorpay)</li>
            <li>Study/attendance data (check-in, focus stats where enabled)</li>
            <li>Device/technical data (FCM token, app version) for notifications and support</li>
            <li>Optional location when a Manager sets library address on a map</li>
          </ul>
          <p>
            Where the registration flow collects Aadhaar for Student ID generation, it is used
            only for library registration — not sold or used for advertising. See the{' '}
            <a href={sanctuaryLinks.privacyFull} target="_blank" rel="noopener noreferrer">
              full policy
            </a>{' '}
            for details.
          </p>

          <h2>4. How we use information</h2>
          <ul>
            <li>Operate accounts, seats, memberships, and attendance features</li>
            <li>Process payments through Razorpay and record Manager-initiated cash payments</li>
            <li>Send alerts (plan expiry, broadcasts, payment confirmations)</li>
            <li>Support, security, fraud prevention, and legal compliance</li>
          </ul>
          <p>We do not sell personal information for third-party marketing.</p>

          <h2>5. Sharing</h2>
          <p>
            Processors acting on our instructions may include Google Firebase, Razorpay, and
            Cloudinary (uploads). We may disclose data if required by law. We do not sell or
            rent personal data to advertisers.
          </p>

          <h2>6. Retention, security &amp; rights</h2>
          <p>
            Data is retained while accounts/service need it, longer where law requires (e.g.
            payment logs). We use HTTPS, Firebase Auth, Firestore rules, and server-side checks
            for sensitive operations. You may request access, correction, or deletion by
            emailing {sanctuaryLinks.email}. Students should also contact their library Manager.
          </p>

          <h2>7. Contact</h2>
          <p>
            {sanctuaryLinks.business}
            <br />
            Email: <a href={`mailto:${sanctuaryLinks.email}`}>{sanctuaryLinks.email}</a>
            <br />
            Phone: <a href={sanctuaryLinks.phoneTel}>+91 {sanctuaryLinks.phone}</a>
            <br />
            {sanctuaryLinks.address}
          </p>
        </article>
      </SanctuaryShell>
    </main>
  );
}

export default SanctuaryPrivacy;
